import React from 'react';

import SEOMeta from '@src/components/SEOMeta';

export default function PrivacyPolicyPage() {
  return (
    <>
      <SEOMeta
        title="プライバシーポリシー"
        description="ICHI-INのプライバシーポリシーページです。"
      />
      <div className="mx-auto max-w-[1000px] bg-white rounded-lg">
        <div className="py-4 m-6">
          <div className="my-6">
            <h1 className="my-8 text-3xl text-center">プライバシーポリシー</h1>
            <p>
              株式会社Ojiiy（以下，「当社」といいます。）は，本ウェブサイト上で提供するイチイン（以下,「本サービス」といいます。）における，ユーザーの個人情報の取扱いについて，以下のとおりプライバシーポリシー（以下，「本ポリシー」といいます。）を定めます
            </p>
          </div>

          <div className="my-4">
            <h2 className="my-2 text-xl">第1条（個人情報）</h2>
            <p>
              本サービスにおける個人情報とは利用時に登録する、氏名（ニックネーム），生年月日，住所，電話番号，連絡先、その他の記述等により特定の個人を識別できる情報及び画像などから、特定の個人を識別できる情報のことを指します。
            </p>
          </div>

          <div className="my-4">
            <h2 className="my-2 text-xl">第2条（個人情報の収集方法）</h2>
            <p>
              本サービスを利用する際に、氏名，生年月日，居住地域
              ,メールアドレス，クレジットカード番号（2021年8月現在は不要）等の個人情報を登録します。
            </p>
            <p>
              登録ができない場合は、サービスの利用をお断りする場合がありますので予めご了承ください。
            </p>
          </div>

          <div className="my-4">
            <h2 className=" my-2 text-xl">
              第3条（個人情報を収集・利用する目的）
            </h2>
            <p>
              当社がユーザーの個人情報を登録・利用するのは以下の理由からです。
            </p>
          </div>

          <ul className="ml-4 list-disc">
            <li>本サービスの提供及び、ユーザーが快適に利用するため</li>
            <li>ユーザーからのお問い合わせに回答するため</li>
            <li>本人確認を行うため</li>
            <li>
              サービスの更新情報,新機能,お知らせ,キャンペーン情報を通知するため
            </li>
            <li>サービスのメンテナンス等重要なお知らせを通知するため</li>
            <li>
              利用規約に違反したユーザー,不正・不当な目的で利用するユーザーを特定し、利用をお断りするため
            </li>
            <li>
              頂いたユーザー情報から、属性及び分析を行い、サービス向上に役立てるため
            </li>
            <li>個人が一切特定できない範囲で、外部向けに資料を作成するため</li>
            <li>上記の利用目的に付随する目的</li>
          </ul>

          <div className="my-4">
            <h2 className=" my-2 text-xl">第4条（利用目的の変更）</h2>
            <p>
              個人情報の利用目的が、変更前と関連性が認められる場合に限る、個人情報の利用目的を変更します。
            </p>
            <p>
              利用目的の変更を行った場合には，変更後の目的について，当社所定の方法により，ユーザーに通知し，または本ウェブサイト上に公表するものとします。
            </p>
            <p>
              利用目的の変更を行った場合は、変更後の目的をユーザーに通知及び本ページ内に公表します。
            </p>
          </div>

          <div className="my-4">
            <h2 className=" my-2 text-xl">第5条（個人情報の第三者提供）</h2>
            <p>
              当社では、ユーザーの同意なく第三者に個人情報を提供しません。ただし、次の場合に第三者へ提供する場合があります。
            </p>
          </div>

          <ul className="ml-4 list-disc">
            <li>個人情報の第三者への提供に関して同意を得たとき</li>
            <li>
              人の生命，身体または財産の保護のために必要がある場合であって，本人の同意を得ることが困難であるとき
            </li>
            <li>
              国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって，本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
            </li>
            <li>
              公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、ご本人の同意を得ることが困難であるとき
            </li>
          </ul>

          <p>
            前項の定めにかかわらず，次に掲げる場合には，当該情報の提供先は第三者に該当しないものとします。
          </p>
          <ul className="ml-4 list-disc">
            <li>
              当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合
            </li>
            <li>
              合併その他の事由による事業の承継に伴って個人情報が提供される場合
            </li>
            <li>
              個人情報を特定の者との間で共同して利用する場合であって，その旨並びに共同して利用される個人情報の項目，共同して利用する者の範囲，利用する者の利用目的および当該個人情報の管理について責任を有する者の氏名または名称について，あらかじめ本人に通知し，または本人が容易に知り得る状態に置いた場合
            </li>
          </ul>

          <div className="my-4">
            <h2 className=" my-2 text-xl">第6条（個人情報の訂正および削除）</h2>
            <p>
              当社では，保有する個人情報に対し本人又は代理人と認められた場合に限り、訂正，追加,削除,利用停止,消去,開示を請求することができます。
            </p>
            <p>
              ユーザー自身で個人情報を変更される場合は、サービス内所定フォームより手続きを行ってください。
            </p>

            <p>
              本人から個人情報の開示を求められたときは，本人に対し，遅滞なくこれを開示します。ただし，開示することにより次のいずれかに該当する場合は，その全部または一部を開示しないこともあり，開示しない決定をした場合には，その旨を遅滞なく通知します。
            </p>

            <ul className="ml-4 list-disc">
              <li>
                本人または第三者の生命，身体，財産その他の権利利益を害するおそれがある場合
              </li>
              <li>
                当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合
              </li>
              <li>その他法令に違反することとなる場合</li>
            </ul>

            <p>
              前項の定めにかかわらず，履歴情報および特性情報などの個人情報以外の情報については，原則として開示いたしません。
            </p>
          </div>

          <div className="my-4">
            <h2 className=" my-2 text-xl">第7条（個人情報の利用停止等）</h2>
            <p>
              当社は，本人から，個人情報が，利用目的の範囲を超えて取り扱われているという理由，または不正の手段により取得されたものであるという理由により，その利用の停止または消去（以下，「利用停止等」といいます。）を求められた場合には，遅滞なく必要な調査を行います。
            </p>
            <p>
              前項の調査結果に基づき，その請求に応じる必要があると判断した場合には，遅滞なく，当該個人情報の利用停止等を行います。
            </p>
            <p>
              当社は，前項の規定に基づき利用停止等を行った場合，または利用停止等を行わない旨の決定をしたときは，遅滞なく，これをユーザーに通知します。
            </p>
          </div>

          <div className="my-4">
            <h2 className=" my-2 text-xl">
              第8条（プライバシーポリシーの変更）
            </h2>
            <p>
              本ポリシーの内容は，ユーザーに通知することなく，変更することができるものとします。
            </p>
            <p>
              当社が別途定める場合を除いて，変更後のプライバシーポリシーは，本ウェブサイトに掲載したときから効力を生じるものとします。
            </p>
          </div>

          <div className="my-4">
            <h2 className=" my-2 text-xl">第9条（お問い合わせ窓口）</h2>
            <p>
              本ポリシーに関するお問い合わせは，下記の窓口までお願いいたします。
            </p>
            <p>住所：神奈川県鎌倉市</p>
            <p>社名：株式会社Ojiiy</p>
            <p>Eメールアドレス：kishimoto@ojiiy.com</p>
          </div>
        </div>
      </div>
    </>
  );
}
